<template>
    <div class="grid grid-cols-1 gap-6">
        <div class="flex flex-col bg-white rounded-lg shadow">
            <div class="p-4">
                <div class="font-semibold">
                    {{ $t('Recieved Invoices ') }}
                    <select v-model="visible" class="form-select form-select-lg mb-3 appearance-none block w-full px-4  py-2 text-xl font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300
                       rounded transition ease-in-out m-0
                       focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none">
                        <option value="1">Line-Chart</option>
                        <option value="2">Bar-Chart</option>
                        <option value="3">Doughnut</option>
                    </select>
                </div>
            </div>
            <div class="p-4">
                <loading :status="loading"/>
                <BarChart ref="chart" :chart-data="chartData" :height="350" v-if="visible ==2"></BarChart>
                <PieChart ref="chart" :chart-data="chartData" :height="350" v-if="visible ==3"></PieChart>
                <line-chart ref="chart" :chart-data="chartData" :height="350" v-if="visible ==1"></line-chart>
            </div>
        </div>
    </div>
</template>

<script>
import LineChart from "@/components/charts/line-chart";
import BarChart from "@/components/charts/bar-chart";
import PieChart from "./pie-com"
export default {
    name: "opened-tickets",
    components: {LineChart,PieChart,BarChart},
    data() {
        return {
            visible:1,
            loading: true,
            chartData: {
                labels: [
                    this.$t('Jan'), this.$t('Feb'), this.$t('Mar'), this.$t('Apr'), this.$t('May'), this.$t('Jun'), this.$t('Jul'), this.$t('Aug'), this.$t('Sept'), this.$t('Oct'), this.$t('Nov'), this.$t('Dec'),
                ],

                datasets: [
                    {
                        label: this.$i18n.t('Recieved Invoices'),
                        backgroundColor: '#4299e1',
                        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                    }
                ],
            }
        }
    },
    computed: {
        datasets() {
            return this.chartData.datasets[0].data
        }
    },
    watch: {
        datasets() {
            this.$refs.chart.update();
        }
    },
    mounted() {
        this.getData();
    },

    methods: {
        getData() {
            const self = this;
            self.loading = true;
            axios.get('api/dashboard/stats/opened-tickets').then(function (response) {
                self.chartData.datasets[0].data = response.data;
                self.loading = false;
            });
        }
    },

}
</script>
